export default __webpack_public_path__ + "static/media/tornado.e93e6b28.svg";